import type { Section } from "./Section";

export const INITIAL_VALUES_SECTION: Section = {
	SectionId: null,
	SectionName: "",
	FormId: null,
	SortOrder: null,
	Subtitle: "",
	BackgroundColor: "#FFFFFF",
	LayoutParameters: "Column=1",
	IsActive: true,
};
